import { render, staticRenderFns } from "./add-department.vue?vue&type=template&id=e7bad424&scoped=true"
import script from "./add-department.vue?vue&type=script&lang=js"
export * from "./add-department.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bad424",
  null
  
)

export default component.exports